module.exports = __webpack_public_path__ + "b11611aa6738d9de871bc85a8ee54d51.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg52.jpeg
// module id = 64
// module chunks = 0